import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Logger } from './logger.service';

const disable = (): any => undefined;

@Injectable()
export class LoggerConfigService implements Logger {
    constructor() {}
    get info() {
        if (environment.production) {
            return disable;
        }
        return console.info.bind(console);
    }
    get warn() {
        if (environment.production) {
            return disable;
        }
        return console.warn.bind(console);
    }
    get error() {
        if (environment.production) {
            return disable;
        }
        return console.error.bind(console);
    }
}
